import { render, staticRenderFns } from "./taoBaiViet.vue?vue&type=template&id=cd71e730&scoped=true&"
import script from "./taoBaiViet.vue?vue&type=script&lang=js&"
export * from "./taoBaiViet.vue?vue&type=script&lang=js&"
import style0 from "./taoBaiViet.vue?vue&type=style&index=0&id=cd71e730&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd71e730",
  null
  
)

export default component.exports